<template>
	<div>
		<b-overlay :show="is_load" rounded="sm">
			<div class="panel-tag">
				{{__t("CITY_TAG_PUBLISH")}}
			</div>

			<h5 class="frame-heading">{{__t("PUBLISHED_TTL")}}</h5>
			<div class="custom-control custom-checkbox custom-control-inline">
				<input type="checkbox" v-model="city.published" class="custom-control-input" id="publish">
				<label class="custom-control-label" for="publish">{{__t("PUBLISHED")}}</label>
			</div>

			<div class="skeep_sync mt-5">
				<h5 class="frame-heading">{{__t("SKEEP_TTL")}}</h5>
				<div class="custom-control custom-checkbox custom-control-inline">
					<input type="checkbox" v-model="city.skeep_sync" class="custom-control-input" id="skeep_sync">
					<label class="custom-control-label" for="skeep_sync">{{__t("SKEEP_SYNC")}}</label>
				</div>
			</div>

		</b-overlay>

	</div>
</template>

<script>
export default {
	name: "city_settings",

	props : {
		city : {
			type : Object
		}
	},
	data() {
		return {
			is_load: false,
		}
	},

	beforeDestroy() {
		EventBus.$off('save_city_called',this.save_city);
	},

	created() {
		EventBus.$on("save_city_called",this.save_city)
	},

	methods : {
		async save_city() {
			this.is_load = true;
			await api.put('/internal/v1/catalog/cities/'+ parseInt(this.city.id),this.city).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					EventBus.$emit("close_city");
					EventBus.$emit("reload_cities");
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {
					err: response.data.message,
					type: "danger",
					title: response.data.status,
					position : "b-toaster-top-left",
				})
			});
		},

	}
}
</script>

<style scoped>

</style>
